import { useQuery } from '@tanstack/react-query'

import { CAR_QUERY_KEYS } from '@/entities/car/lib'
import { IVehicleOptions } from '@/entities/car/model'

import { getVehicleOptions } from '../request/carApis'

const useVehicleOptionsQuery = ({
  standardId,
  fuelType,
}: {
  standardId?: number | null
  fuelType?: string | null
}) => {
  return useQuery<IVehicleOptions | null>({
    queryKey: CAR_QUERY_KEYS.VEHICLE_OPTIONS.detail({ standardId, fuelType }),
    queryFn: () =>
      getVehicleOptions({
        standardId: standardId!,
        fuelType: fuelType ?? undefined,
      }),
    enabled: !!standardId,
    throwOnError: false,
  })
}

export default useVehicleOptionsQuery
